import {MonitoringGroupLevel, MonitoringGroupLevelRank, MonitoringServer} from "@/lib/types/monitoring";

export const isInternal = (server: MonitoringServer) => {
  const location = (server.location || "").trim().toUpperCase();
  return location === "TEST" || location === "AUTO";
};

export const isAvailable = (obj: MonitoringServer, userMonitoringLevel?: MonitoringGroupLevel) => {
  if (isInternal(obj)) return true;

  return (
    MonitoringGroupLevelRank[userMonitoringLevel ?? MonitoringGroupLevel.LEVEL_0] >=
    MonitoringGroupLevelRank[obj.monitoring_level as MonitoringGroupLevel]
  );
};
